import type { SVGProps } from 'react';

interface LogoPiece2IconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const LogoPiece2Icon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & LogoPiece2IconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 46 38"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#logo_piece-2_svg__a)" fill="#4FA9FF" opacity={0.3}>
      <path d="M6.508 56.406A36.4 36.4 0 0 1 .624 36.504c0-4.601.849-8.995 2.396-13.053 1.192.372 2.411.752 3.617 1.124 5.527 1.71 9.557 1.581 11.019 3.75.692 1.016.342 9.36 0 17.44-.285 6.734-1.933 7.32-7.582 9.332-1.048.372-2.232.794-3.566 1.316zM56 5.374q-.254.218-.541.444c-3.417 2.72-14.25 10.284-16.22 10.284-1.968 0-4.928-.709-7.638-7.056-.899-2.097-2.275-4.66-3.638-7.192-.114-.208-.228-.423-.342-.63A36.4 36.4 0 0 1 36.986 0c6.968 0 13.473 1.96 19 5.367zM4.276 20.539C8.256 12.337 15.21 5.86 23.726 2.512c1.027 2.991 2.432 5.41 3.688 7.564 1.248 2.147 2.346 4.036 2.781 5.983.878 3.936-7.93 8.673-10.07 9.26-1.013.28-2.283-.336-3.988-1.166-1.89-.916-4.322-2.097-7.538-2.605-1.291-.208-2.775-.566-4.315-1.016zM50.209 43.71c.506 5.726.955 10.771-3.117 11.923-4.13 1.167-10.32.902-13.93 0-.435-.107-.941-.229-1.49-.365-4.037-.973-10.635-2.554-11.02-4.422-.906-4.394-.257-9.568.514-14.735.777-5.174 1.034-6.334 2.253-7.114.628-.393 2.647-2.512 4.75-4.709 2.019-2.11 4.109-4.3 5.122-5.13 1.176-.967 4.322.686 7.546 2.382l6.64 2.806c2.168.916 2.753 7.07 2.646 12.967-.043 2.319-.079 4.523.064 6.162l.022.229zM53.047 21.196c.941-2.426 4.693-12.43 2.41-11.75-2.275.672-16.068 9.51-13.044 10.519.535.179 3.937 1.36 4.529 1.582 2.753 1.03 5.328 1.653 6.105-.344z" />
    </g>
    <defs>
      <clipPath id="logo_piece-2_svg__a">
        <path d="M0 0h46v38H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
